import { useQuery } from '@tanstack/react-query';
import { apiRequest } from '../lib/api';

export interface RuntimeConfig {
  meta_features_enabled: boolean;
  /** Lot 2 — publication via agrégateur (flag serveur, allumé sans rebuild). */
  publishing_enabled: boolean;
  /** Lot 3.1 — Inéa sur WhatsApp pour les membres. */
  whatsapp_member_enabled: boolean;
  direct_signup_enabled: boolean;
  /** Module Automatisations (lot 1a, 2026-10-28) — mot-clé → DM → scénario. */
  automations_enabled: boolean;
}

const SAFE_DEFAULT: RuntimeConfig = { meta_features_enabled: false, direct_signup_enabled: false, publishing_enabled: false, whatsapp_member_enabled: false, automations_enabled: false };

/**
 * Runtime feature flags (Lot A 2026-07-20). Served by the public GET /config —
 * lets us hide features without a front rebuild. Safe default: everything
 * hidden while loading or on error.
 */
export function useFeatures(): RuntimeConfig & { loaded: boolean } {
  const { data, isFetched, isError } = useQuery({
    queryKey: ['runtime-config'],
    queryFn: () => apiRequest<RuntimeConfig>('/config', { auth: false }),
    staleTime: 5 * 60_000,
    retry: 1,
  });
  // `loaded` : la réponse est arrivée (ou a échoué → défauts sûrs). Les gardes de
  // routes DOIVENT l'attendre, sinon un flag allumé redirige à tort pendant le
  // chargement (bug trouvé par la fumée Lot 2, 03/09/2026).
  return { ...(data ?? SAFE_DEFAULT), loaded: isFetched || isError };
}
